import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {AudioTranscriptionModel} from "../../../api/model/audioTranscription.model";
import {AudioTranscriptionConverter} from "../../../api/model/converter/audioTranscription.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";

@Injectable({
    providedIn: 'root'
})
export class AudioTranscriptionDataService extends AbstractDataServiceV2<AudioTranscriptionModel, AudioTranscriptionConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: AudioTranscriptionConverter) {
        super('AudioTranscription', http, httpUrlGenerator, logger, config, converter);
    }
}
